const businessCardStyle = () => ({
    spacing: {
        padding: '15px 0',
    },
    clearPadding: {
        marginLeft: '-15px',
        marginRight: '-15px',
    },
    colorTextInput: {
        '& input': {
            color: '#4b4b4b',
        },
        '& label.Mui-focused': {
            color: '#4b4b4b',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#4b4b4b',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: '#4b4b4b',
            },
        },
    },
});

export default businessCardStyle;
